import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Modern covers",
  "description": "",
  "published": "2007-07-13T00:00:00.000Z",
  "redirect_from": ["/blog/modern-covers/swizec/172"],
  "categories": "intrigues",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last night I came across yet another song that I thought was awesome, but turned out to be a cover of an 80's electropop or synthpop or electronica or whatever the genre song. Really, too many way too similar genres in the 80's, bloody annoying. Anyhoo ...`}</p>
    <p>{`What strikes me as odd is that all covers I find are better than their electropop originals, which is vastly different to modern covers of 80's rock music that are usually much worse and simply not as good in any way. Usually modern rock covers lack a certain emotion behind them, while the old electropop music seems to lack the emotion behind the modern interpretations.`}</p>
    <p>{`Take `}<a parentName="p" {...{
        "href": "http://youtube.com/watch?v=OufZbzsUtIo"
      }}>{`Eurhythmics' Sweet Dreams`}</a>{`, sure cool song, nice to listen, but utterly annoying in the way it's done. Now take `}<a parentName="p" {...{
        "href": "http://youtube.com/watch?v=3iuve2OjY_8"
      }}>{`Marylin Manson's cover`}</a>{` of the same song and you will notice it has much more feeling behind it, sounds better and just feels much more suited to the lyrics. `}<a parentName="p" {...{
        "href": "http://youtube.com/watch?v=4NAPw8N5vM8"
      }}>{`Fear for Tears' Mad World`}</a>{` is a similar example, the original doesn't seem to fit the depressing lyrics at all and is very silly in its appearance, while the `}<a parentName="p" {...{
        "href": "http://youtube.com/watch?v=v52Igdotisk"
      }}>{`Michael Andrews/Gary Jules version`}</a>{` is perfectly suited for the lyrics, slow depressing and awesome sounding.`}</p>
    <p>{`The most interesting difference I see is that the modern version as a rule have a slower tempo, deeper, more sensual voice and simpler music, much simpler. Is it just the times that change so much, the overall preferences in people's taste or is it just that 80's synthpop simply wasn't good music?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      